'use strict';
define([
    'angular',
    'modules/settings/digitalGiftBox/digitalGiftBox.controller'
],function(angular, DigitalGiftBoxController){
    var app = angular.module('settings.digitalGiftBox', []);
    app.controller('DigitalGiftBoxController', DigitalGiftBoxController);
    return app;
});